<template>
  <div>
    <div class="relative">
      <autoresizing-text-area
        v-model="modelValue"
        :name="name"
        :rows="rows"
        :placeholder="label"
        v-bind="$attrs"
        :auto-focus="false"
        @blur="emit('blur')"
      />
      <label
        v-if="label && !hideLabel"
        v-show="modelValue && String(modelValue).length"
        :for="name"
        class="absolute top-0 left-0 z-1 -mt-3 ml-2-5 flex max-w-17/20 items-center gap-1 truncate bg-white px-1 pr-2 text-xs leading-6"
        :class="labelColor || 'text-gray-400'"
      >
        {{ label }}
        <slot name="label-suffix" />
      </label>
    </div>
    <div v-if="message" :class="messageClass" class="-mt-6 ml-1 text-sm">
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { ValidationState } from "@/enums/validation";

import AutoresizingTextArea from "@/views/deals/components/dealNotes/AutoresizingTextArea.vue";

defineOptions({
  inheritAttrs: false,
});

interface Props {
  name: string;
  label?: string;
  hideLabel?: boolean;
  labelColor?: string;
  rows?: number;
  message?: string;
  messageType?: ValidationState;
}

const { rows = 6, messageType = ValidationState.Idle } = defineProps<Props>();

const modelValue = defineModel<string>();

const emit = defineEmits<{
  blur: [];
}>();

const messageClass = computed(() => {
  if (messageType === ValidationState.Success) {
    return "text-green-600";
  }
  if (messageType === ValidationState.Error) {
    return "text-red-600";
  }
  return "text-gray-600";
});
</script>
